import { all, takeLatest } from 'lib/redux';
import { GET_USER_ENTITLEMENTS } from 'constants/ActionTypes';
import getUserEntitlementsSaga from './UserEntitlements.saga';

/**
 * Defines the watchers related to User Entitlements.
 * These watchers will be imported in store/RootSaga.js
 */
export default function* watchers() {
  yield all([
    takeLatest(GET_USER_ENTITLEMENTS, getUserEntitlementsSaga),
  ]);
}
